import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";

const Nagarbandhu = () => {
    const { t } = useTranslation();
    return (
        <>
            <section id="hero" className="hero hero2">
                <LeftSocialMediaIconUI />

                <div className="carousel-item active">
                    <img src="assets/img/inner-bg2.png" className="img-fluid" alt />
                    <div className="container">
                        <div className="section-main-heading2"></div>
                    </div>
                </div>
            </section>
            {/* End Slider */}

            <section className="section inner-pad1">
                <div className="container ">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="site-menu ">
                                <nav className="sidebar card py-2">
                                    <ul className="nav flex-column" id="nav_accordion">
                                        <li className="nav-item">
                                            <Link
                                                className="nav-link active1 fontSizeClass"
                                                to="/Nagarbandhu"> {t("Nagar Bandhu")}
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div class="dig-login1 dig-form min-hg">
                                <form><div class="log-form">
                                    <div class="container">
                                        <div class="row">
                                            <h3 class="fontSizeClass">Nagar Bandhu Success Stories</h3>
                                            {/* <p class="subtitle">Nagar Bandhu Success Stories</p> */}
                                            <div class="col-xl-12 col-md-12 mb-12 form-group pt-2 frms">
                                              <div class="list-of-forms">
                                                <h6>
                                                <DownloadFileByFileStoreId fileStoreId={ "8c9c14f0-a160-4b2f-9677-320362df66fa" } label="January 2024" />
                                                </h6>
                                               </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </form>
                            </div>
                            {/* <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass"> {t("Nagar Bandhu Success Stories")} </h3>
                  </div>
                  <div className="mayor-table2">

                    <table className="table table-bordered">
                      <tbody>
                        <tr className="table-warning table-bor-2">
                          <td>{t("Nagar Bandhu Success Stories")}</td>
                          
                        </tr>
                        <tr>
                            <td> 
                            <DownloadFileByFileStoreId fileStoreId={ "" } label="January 2024" />
                            </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Nagarbandhu;
